import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking/cooking-cookbook/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-cookbook/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-cookbook/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking/cooking-cookbook/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-cookbook/detail',
    method: 'get',
    params: { id }
  })
}
